'use strict'

import { underline } from '../modules/concert-nav';
import { getPerformances } from '../services/inventory';
import { getPackages } from '../services/package';
import { loadComponent } from './utils/load-component';
import zonedDate from "../utils/zoned-date";

loadComponent('subscription-list', {
    props: {
        productionSeasons: {
            type: Array,
        },
        performances: {
            type: Array,
        },
    },

    data() {
        return {
            ViewModel: {
                Loading: true,
                Subscriptions: [],
                //These values are set in performance-list.js beforeMount
                // HasAvailability: useState('performanceHasAvailability', false),
                HasAvailability: false,
                // IsOnSale: useState('performanceIsOnSale', false),
                IsOnSale: false,
            },
        }
    },

    beforeMount() {
        const packagesPromise = getPackages();

        const performancesPromise = getPerformances().then(performancesResponse => {
            if (this.performances.length) {
                return performancesResponse.filter(item => {
                    return this.performances.indexOf(item.PerformanceNumber) !== -1;
                });
            }

            if (this.productionSeasons.length) {
                return performancesResponse.filter(perf => {
                    return this.productionSeasons.indexOf(perf.ProductionSeasonNumber) !== -1;
                });
            }

            return [];
        });

        Promise.all([ packagesPromise, performancesPromise ]).then(responses => {
            const [ packagesResponse, performancesResponse ] = responses;

            const performanceNumbers = performancesResponse.map(item => {
                return item.PerformanceNumber;
            });

            this.ViewModel.Subscriptions = packagesResponse.filter(item => {
                return item.Performances.some(performance => {
                    return performanceNumbers.indexOf(performance.Id) !== -1;
                });
            });

            const now = zonedDate();

            this.ViewModel.HasAvailability = !!performancesResponse.find(item => item.Availability > 0);
            this.ViewModel.IsOnSale = !!this.ViewModel.Subscriptions.find(item => zonedDate(item.StartSaleDate) < now && now < zonedDate(item.EndSaleDate));

            this.ViewModel.Loading = false;

            // Subscription heading is hidden by default and only shown if subscriptions exist
            if (this.ViewModel.Subscriptions.length) {
                document.querySelector('[href="#subscriptions"]').closest('.concert-navigation__item').classList.remove('hidden');
                const concertNav = document.querySelector('.concert-navigation');
                if (concertNav) {
                    underline(document.querySelector('.concert-navigation__link.active'));
                }
            }
        });
    },

    onMounted() {
        const observer = new MutationObserver(() => {
            const subscriptionsLink = document.querySelector('.concert-navigation__item a[href="#subscriptions"]');
            if (subscriptionsLink) {
                const activeLink = document.querySelector('.concert-navigation__link.active');
                if (activeLink) {
                    underline(activeLink);
                }
            }
        });

        observer.observe(document.querySelector('.concert-navigation'), {
            childList: true,
            subtree: true,
        });
    },

    methods: {
        scrollToSubscriptions(event) {
            event.preventDefault();

            const element = document.querySelector('#subscriptions');

            if (!element) {
                return;
            }

            let headerOffset = 0;

            const header = document.querySelector('.global-alert');

            if (header) {
                headerOffset = header.getBoundingClientRect().height;
            }

            const style = element.currentStyle || window.getComputedStyle(element);

            const offsetPosition = element.getBoundingClientRect().top + window.pageYOffset - headerOffset - parseFloat(style.marginTop);

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            });
        },
    },
});
